import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Banner, IBannerDispatchProps } from './Banner';

import { IState } from '../../../../store';
import { closeBanner } from '../../actions';

export function mapDispatchToProps(dispatch: Dispatch<IState>): IBannerDispatchProps {
  return {
    closeBanner: () => dispatch(closeBanner()),
  };
}

export const BannerContainer = connect<null, IBannerDispatchProps>(null, mapDispatchToProps)(Banner);
